import { ASSISTANT_PAGE_MARKER } from './assistant.js';
const BULLET = /^\s*[-*•]\s+(.*)$/;
const NUMBERED = /^\s*\d{1,3}[.)]\s+(.*)$/;
const HEADING = /^\s*#{1,6}\s+(.*)$/;
/** Bold, code and page markers within one line. Anything unmatched (a lone `**`, a stray `) stays text. */
export function parseAssistantInline(line, allowBold = true) {
    const out = [];
    const marker = ASSISTANT_PAGE_MARKER.source;
    // Earliest of: `code`, **bold**, [[page:…]]. Code wins inside bold's span because it is tried first.
    const re = new RegExp(`\`([^\`\\n]+)\`|\\*\\*(?=\\S)([^\\n]*?\\S)\\*\\*|${marker}`, 'g');
    let last = 0;
    for (let m = re.exec(line); m; m = re.exec(line)) {
        if (m.index > last)
            out.push({ t: 'text', v: line.slice(last, m.index) });
        last = m.index + m[0].length;
        if (m[1] !== undefined)
            out.push({ t: 'code', v: m[1] });
        else if (m[2] !== undefined) {
            if (allowBold)
                out.push({ t: 'bold', v: parseAssistantInline(m[2], false) });
            else
                out.push({ t: 'text', v: m[2] });
        }
        else
            out.push({ t: 'page', key: m[3], ...(m[4] ? { id: m[4] } : {}) });
    }
    if (last < line.length)
        out.push({ t: 'text', v: line.slice(last) });
    return out;
}
/** Paragraphs (blank-line separated, single line breaks kept), bullet and numbered lists, heading lines. */
export function parseAssistantText(text) {
    const blocks = [];
    let para = [];
    let list = null;
    const flushPara = () => {
        if (!para.length)
            return;
        const v = [];
        para.forEach((line, i) => {
            if (i > 0)
                v.push({ t: 'break' });
            v.push(...parseAssistantInline(line));
        });
        blocks.push({ t: 'p', v });
        para = [];
    };
    const flushList = () => {
        if (list)
            blocks.push(list);
        list = null;
    };
    for (const raw of text.replace(/\r\n?/g, '\n').split('\n')) {
        const line = raw.trimEnd();
        if (!line.trim()) {
            flushPara();
            flushList();
            continue;
        }
        const bullet = BULLET.exec(line);
        const numbered = bullet ? null : NUMBERED.exec(line);
        if (bullet || numbered) {
            flushPara();
            const t = bullet ? 'ul' : 'ol';
            if (list && list.t !== t)
                flushList();
            list ??= { t, items: [] };
            list.items.push(parseAssistantInline((bullet ?? numbered)[1]));
            continue;
        }
        const heading = HEADING.exec(line);
        if (heading) {
            flushPara();
            flushList();
            blocks.push({ t: 'heading', v: parseAssistantInline(heading[1], false) });
            continue;
        }
        // An indented line straight after a list item continues that item; anything else ends the list.
        if (list && !para.length && /^\s+\S/.test(raw)) {
            const items = list.items;
            items[items.length - 1].push({ t: 'break' }, ...parseAssistantInline(line.trim()));
            continue;
        }
        flushList();
        para.push(line);
    }
    flushPara();
    flushList();
    return blocks;
}
//# sourceMappingURL=assistant-text.js.map